import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUSES = ["VERIFIED", "CORROBORATED", "ONE SIDE ONLY", "SINGLE APPROVED SOURCE", "DISPUTED", "INSUFFICIENT EVIDENCE", "OPINION / NOT A FACTUAL CLAIM"];

export const CorrectFact = ({ f, onDone }) => {
  const [open, setOpen] = useState(false);
  const [v, setV] = useState({ note: "", headline: f.headline, summary: f.summary, status: f.status });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const changed = Object.fromEntries(["headline", "summary", "status"].filter((k) => v[k] !== f[k]).map((k) => [k, v[k]]));
      const { data } = await api.post(`/admin/facts/${f.id}/corrections`, { note: v.note, ...changed });
      toast.success(`Correction published. ${data.notified} reader${data.notified === 1 ? "" : "s"} notified.`);
      setOpen(false); onDone(data);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button size="sm" variant="outline" className="mt-4 rounded-full" onClick={() => setOpen(true)} data-testid="fact-correct-btn">Issue a correction</Button>
      <DialogContent data-testid="fact-correct-dialog">
        <DialogHeader><DialogTitle className="font-serif text-2xl font-medium">Correct this fact</DialogTitle></DialogHeader>
        <Textarea rows={3} value={v.note} onChange={(e) => setV({ ...v, note: e.target.value })} placeholder="What was wrong and what changed (shown publicly)" data-testid="fact-correct-note" />
        <Input value={v.headline} onChange={(e) => setV({ ...v, headline: e.target.value })} placeholder="Headline" data-testid="fact-correct-headline" />
        <Textarea rows={3} value={v.summary} onChange={(e) => setV({ ...v, summary: e.target.value })} placeholder="Summary" data-testid="fact-correct-summary" />
        <Select value={v.status} onValueChange={(s) => setV({ ...v, status: s })}>
          <SelectTrigger data-testid="fact-correct-status"><SelectValue /></SelectTrigger>
          <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
        </Select>
        <p className="text-xs text-slate-500">Everyone who opened or shared this fact gets a notification.</p>
        <Button className="rounded-full" disabled={busy || !v.note.trim()} onClick={save} data-testid="fact-correct-save">{busy ? "Publishing…" : "Publish correction"}</Button>
      </DialogContent>
    </Dialog>
  );
};
